<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import DataTable from 'datatables.net-vue3';
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Monthly Statement Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Monthly Statement Listing",
            items: [
                {
                text: "Monthly Statement Listing",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            invoice_listing:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
            
      
        };
    },
  setup() {
        const {
            canReadCustomers,
            canReadInvoices,
            canCreateInvoices,
            canReadAgingReport,
            arPermissions
        } = usePermissions()
        return {
            canReadCustomers,
            canReadInvoices,
            canCreateInvoices,
            canReadAgingReport,
            arPermissions
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getInvoiceListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/detail/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.invoice_listing = response.data;
                    console.log('xxxxxx='+this.invoice_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        calculateTotal(item) {
            const monthlyAmount = Number(item.total_amount);
            const latePaymentCharges = Number(item.late_payment_charges);

            const totalAmount = monthlyAmount + latePaymentCharges;
            return totalAmount.toFixed(2);
        },

        calculateBalance(item) {
            const totalAmount = Number(item.total_amount);
            const latePaymentCharges = Number(item.late_payment_charges);
            const paidAmount = Number(item.paid_amount);
            const creditsApplied = Number(item.credits_applied);
            const over_pay = Number(item.over_pay);
            const balanceAmount = totalAmount - over_pay + latePaymentCharges - paidAmount - creditsApplied;
            return balanceAmount.toFixed(2);
        }
    },

    components: {
        DataTable,
    },
    mounted() {
        this.getInvoiceListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
   <div class="card-body mb-5" v-if="canReadInvoices">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, ordering: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Ref. No</th>           
                                            <!--th scope="col">Customer Name</th-->           
                                            <th scope="col">Issue Date</th>
                                            <th scope="col">Due Date</th>
                                            <th scope="col">Monthly Amount (RM)</th>
                                            <th scope="col">Late Payment Charge (RM)</th>
                                            <th scope="col">Total Amount (RM)</th>
                                            <th scope="col">Paid Amount (RM)</th>
                                            <th scope="col">Overpaid Amount (RM)</th>
                                            <th scope="col">Credits Applied (RM)</th>
                                            <th scope="col">Balance Amount (RM)</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in invoice_listing" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{item.invoice_no}}</td>                               
                                            <!--td><router-link :to="'/customer/customer-details/'+item.id" class="fw-medium link-secondary">{{item.name_as_per_nric}}</router-link></td-->
                                            <td>{{item.issue_date}}</td>
                                            <td>{{item.due_date}}</td>
                                            <td style="text-align: center">{{item.total_amount}}</td>                                      
                                            <td style="text-align: center">{{item.late_payment_charges}}</td> 
                                            <td style="text-align: center">{{calculateTotal(item)}}</td>                                     
                                            <td style="text-align: center">{{item.paid_amount}}</td>
                                            <td style="text-align: center">{{ parseFloat(item.over_pay).toFixed(2) }}</td>
                                            <td style="text-align: center">{{item.credits_applied}}</td>                                  
                                            <td v-if="calculateBalance(item) > 0" style="text-align: center;color: red">( {{calculateBalance(item)}} )</td> 
                                            <td v-else style="text-align: center">{{calculateBalance(item)}}</td>  
                                            <td v-if="item.status == 'Pending'"><span class="badge bg-primary">Pending</span></td>
                                            <td v-else-if="item.status == 'Paid'"><span class="badge bg-success">Paid</span></td>
                                            <td v-else-if="item.status == 'Partial Payment'"><span class="badge bg-warning">Partial Paid</span></td>
                                            <td v-else><span class="badge" style="background-color: #fe002a">Overdue</span></td>                                  
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="ri-more-fill align-middle"></i>
                                                    </button>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <router-link class="dropdown-item" :to="'/ar/invoice/view/'+item.id"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> Monthly Statement Details</router-link>
                                                        </li>
                                                        <li v-if="canCreateInvoices">
                                                            <router-link class="dropdown-item" :to="'/ar/credit_notes/create/'+item.id"><i class="ri-file-text-line align-bottom me-2 text-muted"></i> Add Credit Note</router-link>
                                                        </li>
                                                        <li v-if="canCreateInvoices">
                                                            <router-link class="dropdown-item" :to="'/ar/instantpay/'+item.orderId"><i class="ri-secure-payment-fill align-bottom me-2 text-muted"></i> Generate Instant Pay</router-link>
                                                        </li>          
                                                        <!--li>
                                                            <a class="dropdown-item remove-item-btn" @click="deletedata(item)"><i class="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a>
                                                        </li-->
                                                    </ul>
                                                </div>
                                            </td>                                
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    <div v-else class="text-center text-muted p-4">
            You do not have permission to view invoices.
     </div>
</template>
